import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MeetingsStatisticsAPI from '../../../api/MeetingsStatisticsAPI';
import PieChart from '../../../components/PieChart/PieChart';
import NoData from '../../../components/NoData/NoData';

type Props = { timeRange: { start: string; end: string } };

function BookingsPendingPriceRanges({ timeRange }: Props) {
  const { t } = useTranslation();
  const [labels, setLabels] = useState<string[]>([]);
  const [values, setValues] = useState<number[]>([]);

  useEffect(() => {
    let mounted = true;
    MeetingsStatisticsAPI.getBookingsPendingPriceRanges({ startTime: timeRange.start, endTime: timeRange.end })
      .then(({ data }) => {
        if (!mounted) return;
        setLabels(data.labels || []);
        setValues(data.values || []);
      })
      .catch(() => {
        if (!mounted) return;
        setLabels([]);
        setValues([]);
      });
    return () => { mounted = false };
  }, [timeRange.start, timeRange.end]);

  if (!labels.length) {
    return <NoData message={t('global.empty_results')} />;
  }

  return (
    <PieChart
      title={t('stats.bookings_price_ranges') || 'Bookings price ranges'}
      labels={labels}
      data={values}
    />
  );
}

export default BookingsPendingPriceRanges;


